import { MetaApiResponse } from 'utils/types/CommonApiResponse';
import { getQaChunkImportUrl, getQaChunksUrl, getQaChunkUrl } from './apiUrls';
import http from 'utils/http';
import { QaChunkRequest, QaChunkResponse } from './types';

export async function getQaChunks(
  workspaceId: string,
  agentId: string,
  params?: Record<string, any>
): Promise<{ data: QaChunkResponse[]; meta: MetaApiResponse }> {
  const res = await http.get(getQaChunksUrl(workspaceId, agentId), { per_page: 5, ...params });
  return {
    data: res?.data,
    meta: {
      count: res?.count ?? res?.per_page ?? 0,
      total_count: res?.total_count ?? res?.total ?? 0,
      total_pages: res?.total_pages ?? 0
    }
  };
}

export function getQaChunk(workspaceId: string, agentId: string, chunkId: string): Promise<QaChunkResponse> {
  return http.get(getQaChunkUrl(workspaceId, agentId, chunkId));
}

export function createQaChunk(workspaceId: string, agentId: string, payload: QaChunkRequest): Promise<QaChunkResponse> {
  return http.post(getQaChunksUrl(workspaceId, agentId), payload);
}

export function updateQaChunk(
  workspaceId: string,
  agentId: string,
  chunkId: string,
  payload: any
): Promise<QaChunkResponse> {
  return http.patch(getQaChunkUrl(workspaceId, agentId, chunkId), payload);
}

export function deleteQaChunk(workspaceId: string, agentId: string, chunkId: string): Promise<String> {
  return http.delete(getQaChunkUrl(workspaceId, agentId, chunkId));
}

export function importQaChunk(workspaceId: string, agentId: string, payload: FormData): Promise<QaChunkResponse> {
  return http.post(getQaChunkImportUrl(workspaceId, agentId), payload);
}
